<script>
  /* Copyright (c) 2020 Jacques Desodt */
  import AmPm from './AmPm.svelte'
  import TimeValue from './TimeValue.svelte'
  import { createEventDispatcher } from 'svelte'
  import { toggleAmPm } from '../scripts/dates'
  const dispatch = createEventDispatcher()

  export let args
  export let date = new Date()
  export let hoursSelected = true
  /* Local variables */
  let style = 'background-color:' + args.bgColor + ';'

  /* Handles the AM choice event */
  function handleAm () {
    date = toggleAmPm(date, true)
  }

  /* Handles the PM choice event */
  function handlePm () {
    date = toggleAmPm(date, false)
  }

  /* Handles the hours click event */
  function handleHoursClick () {
    hoursSelected = true
    dispatch('hours')
  }

  /* Handles the minutes click event */
  function handleMinutesClick () {
    hoursSelected = false
    dispatch('minutes')
  }
</script>

<div class="_tp-wrapper {args.timeClassName}" style={!args.timeClassName ? style : ''}>
  <TimeValue {args} value={date.getHours()} selected={hoursSelected}
    on:click={handleHoursClick} />
  <div class="_tp-separator">:</div>
  <TimeValue {args} value={date.getMinutes()} selected={!hoursSelected} hour={false}
    on:click={handleMinutesClick} />
{#if !args.is24h}
  <div class="_tp-ampm">
    <AmPm {args} {date}
      on:am={handleAm}
      on:pm={handlePm} />
  </div>
{/if}
</div>

<style>
  ._tp-ampm {
    position: absolute;
    right: 1rem;
    top: 1.1rem;
  }
  ._tp-separator {
    color: rgba(255, 255, 255, 0.6);
    padding: 0.1rem;
  }
  ._tp-wrapper {
    align-items: center;
    display: flex;
    flex-direction: row;
    font-size: 60px;
    height: 6rem;
    justify-content: center;
    position: relative;
    width: 100%;
  }
</style>
